var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtCultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "art-cult-icon",
    transform: "translate(-1407 -2684)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4791",
    "data-name": "Rectangle 4791",
    width: 24,
    height: 24,
    transform: "translate(1407 2684)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "statue",
    transform: "translate(1322.293 2686.418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34648",
    "data-name": "Path 34648",
    d: "M102.791,13.513a.561.561,0,0,0,.561-.561,3.954,3.954,0,0,0-3.93-3.968H98.86V8.42a2.81,2.81,0,0,0,1.082-1.765,1.687,1.687,0,0,0,1.164-1.6V3.93a3.93,3.93,0,0,0-7.861,0V5.053a1.687,1.687,0,0,0,1.164,1.6A2.81,2.81,0,0,0,95.492,8.42v.564H94.93A3.954,3.954,0,0,0,91,12.951a.561.561,0,0,0,.561.561A2.822,2.822,0,0,1,94.314,15.8H92.684a.561.561,0,0,0-.561.561V18.6a.561.561,0,0,0,.561.561h8.983a.561.561,0,0,0,.561-.561V16.357a.561.561,0,0,0-.561-.561h-1.629A2.822,2.822,0,0,1,102.791,13.513ZM97.176,1.123a2.811,2.811,0,0,1,2.766,2.328l-.06-.018a1.258,1.258,0,0,0-1.715-.625,5.345,5.345,0,0,1-2.378.561H94.93a1.678,1.678,0,0,0-.52.082,2.811,2.811,0,0,1,2.766-2.328ZM94.93,5.615a.561.561,0,1,1,0-1.123h.858a6.474,6.474,0,0,0,2.881-.68.133.133,0,0,1,.192.119.561.561,0,0,0,.561.561.561.561,0,1,1,0,1.123.561.561,0,0,0-.561.561,1.684,1.684,0,1,1-3.369,0A.561.561,0,0,0,94.93,5.615Zm6.176,12.427H93.246V16.919h7.861ZM95.452,15.8a3.959,3.959,0,0,0-3.284-3.359,2.822,2.822,0,0,1,2.761-2.331h1.123a.561.561,0,0,0,.561-.561V8.926a2.788,2.788,0,0,0,1.123,0v.619a.561.561,0,0,0,.561.561h1.123a2.822,2.822,0,0,1,2.761,2.331A3.959,3.959,0,0,0,98.9,15.8Z",
    fill: "#6b6b95",
    stroke: "#6b6b95",
    strokeWidth: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtCultIcon);
export default __webpack_public_path__ + "static/media/art-cult-icon.7e0e77d705775a767b688699ce6a9dca.svg";
export { ForwardRef as ReactComponent };